import { render, staticRenderFns } from "./data-statistics.vue?vue&type=template&id=01a73576&scoped=true"
import script from "./data-statistics.vue?vue&type=script&lang=js"
export * from "./data-statistics.vue?vue&type=script&lang=js"
import style0 from "./data-statistics.vue?vue&type=style&index=0&id=01a73576&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a73576",
  null
  
)

export default component.exports